import React, {useCallback, useState} from 'react';
import {Button, Modal} from 'antd';
import styled from "styled-components";
import accountApi from "../../accounts/accounts.service";
import moment from "moment/moment";
import {summarizeProfileBands, toProfiles} from "./collectorProfileView";

export function CollectorResetModal({setModalState, modalState, setForceReload}) {
  const [loading, setLoading] = useState(false);
  const profiles = toProfiles(modalState.modalData);

  const hideModal = useCallback(() => {
    setModalState({
      isVisible: false,
      modalData: {},
      modalType: "",
    });
  }, []);

  const handleClickApply = async () => {
    if (!loading) {
      setLoading(true);
      accountApi.resetCollectorPassword(modalState.modalData.id)
        .then(() => {
          alert("초기화 메일을 성공적으로 전송하였습니다.")
        })
        .catch(() => {
          alert("메일 전송 실패.")
        });
      setLoading(false);
      hideModal();
      setForceReload();
    }
  }

  const ModalFooter = () => {
    return (
      <>
        <Button type="default" onClick={hideModal}>
          취소
        </Button>
        <Button loading={loading} danger type="primary" onClick={handleClickApply}>
          전송
        </Button>
      </>
    )
  }

  return (
    <Modal title={'초기화 메일 전송'}
           onCancel={() => setModalState({
             isVisible: false,
             modalData: {},
           })}
           visible={modalState.isVisible}
           forceRender={true}
           footer={<ModalFooter/>}>
      <AdminUserDataTitle>
        <AdminUserDataValue>유저 이름: </AdminUserDataValue>
        {modalState.modalData.name}
      </AdminUserDataTitle>
      <AdminUserDataTitle>
        <AdminUserDataValue>이메일: </AdminUserDataValue>
        {modalState.modalData.email}
      </AdminUserDataTitle>
      <AdminUserDataTitle>
        <AdminUserDataValue>소속 밴드: </AdminUserDataValue>
        {summarizeProfileBands(profiles)}
      </AdminUserDataTitle>
      <AdminUserDataTitle>
        <AdminUserDataValue>생성 일자: </AdminUserDataValue>
        {moment(modalState.modalData.createdAt).local().format("YYYY-MM-DD HH시 mm분")}
      </AdminUserDataTitle>
    </Modal>
  )
}

const AdminUserDataTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 8px;
`

const AdminUserDataValue = styled.span`
  font-size: 14px;
  font-weight: 600;
`
